/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccessRequestStatus } from './AccessRequestStatus';
import {
    AccessRequestStatusFromJSON,
    AccessRequestStatusFromJSONTyped,
    AccessRequestStatusToJSON,
    AccessRequestStatusToJSONTyped,
} from './AccessRequestStatus';
import type { AccessRequestSearchOrderByPaginationQuery } from './AccessRequestSearchOrderByPaginationQuery';
import {
    AccessRequestSearchOrderByPaginationQueryFromJSON,
    AccessRequestSearchOrderByPaginationQueryFromJSONTyped,
    AccessRequestSearchOrderByPaginationQueryToJSON,
    AccessRequestSearchOrderByPaginationQueryToJSONTyped,
} from './AccessRequestSearchOrderByPaginationQuery';
import type { RoleFilterRequest } from './RoleFilterRequest';
import {
    RoleFilterRequestFromJSON,
    RoleFilterRequestFromJSONTyped,
    RoleFilterRequestToJSON,
    RoleFilterRequestToJSONTyped,
} from './RoleFilterRequest';
import type { PermissionFilterRequest } from './PermissionFilterRequest';
import {
    PermissionFilterRequestFromJSON,
    PermissionFilterRequestFromJSONTyped,
    PermissionFilterRequestToJSON,
    PermissionFilterRequestToJSONTyped,
} from './PermissionFilterRequest';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';
import type { ApplicationFilterRequest } from './ApplicationFilterRequest';
import {
    ApplicationFilterRequestFromJSON,
    ApplicationFilterRequestFromJSONTyped,
    ApplicationFilterRequestToJSON,
    ApplicationFilterRequestToJSONTyped,
} from './ApplicationFilterRequest';

/**
 * 
 * @export
 * @interface AccessRequestSearchRequest
 */
export interface AccessRequestSearchRequest {
    /**
     * 
     * @type {ApplicationFilterRequest}
     * @memberof AccessRequestSearchRequest
     */
    applicationFilter?: ApplicationFilterRequest;
    /**
     * 
     * @type {AccessRequestSearchOrderByPaginationQuery}
     * @memberof AccessRequestSearchRequest
     */
    paginationQuery?: AccessRequestSearchOrderByPaginationQuery;
    /**
     * 
     * @type {RoleFilterRequest}
     * @memberof AccessRequestSearchRequest
     */
    roleFilter?: RoleFilterRequest;
    /**
     * 
     * @type {PermissionFilterRequest}
     * @memberof AccessRequestSearchRequest
     */
    permissionFilter?: PermissionFilterRequest;
    /**
     * 
     * @type {AccessRequestStatus}
     * @memberof AccessRequestSearchRequest
     */
    status?: AccessRequestStatus;
    /**
     * 
     * @type {UserType}
     * @memberof AccessRequestSearchRequest
     */
    userType?: UserType;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccessRequestSearchRequest
     */
    responsiblePersonIds?: Array<string> | null;
}



/**
 * Check if a given object implements the AccessRequestSearchRequest interface.
 */
export function instanceOfAccessRequestSearchRequest(value: object): value is AccessRequestSearchRequest {
    return true;
}

export function AccessRequestSearchRequestFromJSON(json: any): AccessRequestSearchRequest {
    return AccessRequestSearchRequestFromJSONTyped(json, false);
}

export function AccessRequestSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationFilter': json['applicationFilter'] == null ? undefined : ApplicationFilterRequestFromJSON(json['applicationFilter']),
        'paginationQuery': json['paginationQuery'] == null ? undefined : AccessRequestSearchOrderByPaginationQueryFromJSON(json['paginationQuery']),
        'roleFilter': json['roleFilter'] == null ? undefined : RoleFilterRequestFromJSON(json['roleFilter']),
        'permissionFilter': json['permissionFilter'] == null ? undefined : PermissionFilterRequestFromJSON(json['permissionFilter']),
        'status': json['status'] == null ? undefined : AccessRequestStatusFromJSON(json['status']),
        'userType': json['userType'] == null ? undefined : UserTypeFromJSON(json['userType']),
        'responsiblePersonIds': json['responsiblePersonIds'] === undefined ? undefined : json['responsiblePersonIds'] === null ? null : json['responsiblePersonIds'],
    };
}

export function AccessRequestSearchRequestToJSON(json: any): AccessRequestSearchRequest {
    return AccessRequestSearchRequestToJSONTyped(json, false);
}

export function AccessRequestSearchRequestToJSONTyped(value?: AccessRequestSearchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationFilter': ApplicationFilterRequestToJSON(value['applicationFilter']),
        'paginationQuery': AccessRequestSearchOrderByPaginationQueryToJSON(value['paginationQuery']),
        'roleFilter': RoleFilterRequestToJSON(value['roleFilter']),
        'permissionFilter': PermissionFilterRequestToJSON(value['permissionFilter']),
        'status': AccessRequestStatusToJSON(value['status']),
        'userType': UserTypeToJSON(value['userType']),
        'responsiblePersonIds': value['responsiblePersonIds'],
    };
}

